export enum ALIGN_TYPES {
    LEFT = 'left',
    CENTER = 'center',
    RIGHT = 'right',
}
